module.exports = __webpack_public_path__ + "img/research-lab.b652b9fc.svg";